<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Dedication--Front-Matter-"><i>For</i></p>
<p class="ORIM-Dedication--Front-Matter-"><i>My father, Ronald Birtcher</i></p>
<br/>
<p class="ORIM-Dedication--Front-Matter-"><i>and</i></p>
<br/>
<p class="ORIM-Dedication--Front-Matter-"><i>My uncle, Arthur Birtcher</i></p>
<br/>
<p class="ORIM-Dedication--Front-Matter-"><i>and</i></p>
<br/>
<p class="ORIM-Dedication--Front-Matter-"><i>My grandfather, F. E. Birtcher</i></p>
<br/>
<p class="ORIM-Dedication--Front-Matter-"><i>Cowboys all, and keepers of the Code</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?7318d164